import React from "react"
import { Formik, FormikProps } from "formik"
import { Input, Button, Form, Divider } from "@jjordy/layout"

export interface RegisterTenantProps {
  onSubmit: (values: any) => void
  loading: boolean
}

interface FormValues {
  tenantName: string
  tenantDomain: string
}

interface ErrorValues {
  tenantName?: string
  tenantDomain?: string
}

const RegisterTenant: React.SFC<RegisterTenantProps> = ({ onSubmit, loading }) => (
  <Formik
    onSubmit={onSubmit}
    validate={(values: FormValues) => {
      const errors: ErrorValues = {}
      if (!values.tenantName) {
        errors.tenantName = "Organization name required"
      }
      if (!values.tenantDomain) {
        errors.tenantDomain = "Organization domain required"
      }
      return errors
    }}
    initialValues={{ tenantName: "", tenantDomain: "" }}
    render={({ handleSubmit, handleChange, values, errors }: FormikProps<FormValues>) => (
      <Form onSubmit={handleSubmit} loading={loading}>
        <Input
          name="tenantName"
          label="Organization Name"
          type="text"
          onChange={handleChange}
          error={errors.tenantName}
          message={errors.tenantName}
          value={values.tenantName}
        />
        <Input
          name="tenantDomain"
          label="URL where you can access your admin panel"
          type="text"
          onChange={handleChange}
          error={errors.tenantDomain}
          message={errors.tenantDomain}
          value={values.tenantDomain}
        />
        <Divider />
        <Button fluid type="submit" my={1} bg="success" labelPosition="right">
          NEXT
        </Button>
      </Form>
    )}
  />
)

export default RegisterTenant
